import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface RowProps {
  index: number
  children: ReactNode
  className?: string
}

export function Row({ children, index, className = '' }: RowProps) {
  return (
    <div data-testid="row" className={twMerge(`flex ${index !== 0 ? 'border-shades-200 border-t' : ''}`, className)}>
      {children}
    </div>
  )
}
